import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";

import { absoluteUrl, resolveRouteSeo } from "./seoConfig";
import { applySeoMetadata } from "./seoDom";

export default function usePageSeo(options) {
  const location = useLocation();
  const { lang } = useI18n();
  const signature = JSON.stringify(options || {});

  useEffect(() => {
    if (!options) return;
    const routeMeta = resolveRouteSeo(location.pathname, location.search, lang);
    const queryFiltered = Boolean(location.search) && options.allowQueryIndexing !== true;
    const indexable = options.indexable === true && !routeMeta.sensitive && !queryFiltered;
    applySeoMetadata({
      ...routeMeta,
      ...options,
      lang,
      path: location.pathname,
      canonical: options.canonical || absoluteUrl(location.pathname),
      indexable,
      shareable: options.shareable !== false && !routeMeta.sensitive,
      robots: indexable ? "index, follow, max-image-preview:large" : (options.robots || "noindex, follow"),
    });
    // The serialized signature intentionally represents the caller's options.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, signature, lang]);
}
